import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { Button } from "./ui/button";

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const navItems = [
    { path: "/", label: "Accueil" },
    { path: "/a-propos", label: "À propos" },
    { path: "/offres", label: "Offres" },
    { path: "/stop-aux-invendus", label: "Stop aux invendus" },
    { path: "/audit-rentabilite-boulangerie", label: "Diagnostic immersion" },
    { path: "/blog", label: "Blog" },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <header className="fixed top-0 left-0 right-0 bg-[#FBF7EF]/95 backdrop-blur-sm z-50 border-b border-[#4A3A2A]/10">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-2">
            <span className="text-xl sm:text-2xl font-bold text-[#4A3A2A] font-poppins whitespace-nowrap">
              Croissance 🥐consulting
            </span>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-5">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`text-base font-medium transition-colors whitespace-nowrap ${
                  isActive(item.path)
                    ? "text-[#B65C3A]"
                    : "text-[#2D2D2D] hover:text-[#B65C3A]"
                }`}
              >
                {item.label}
              </Link>
            ))}
            <Link to="/contact">
              <Button className="bg-[#B65C3A] hover:bg-[#9d4e2f] text-white font-medium px-5 py-2 text-sm">
                Proposer un échange
              </Button>
            </Link>
          </nav>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden p-2 text-[#4A3A2A] hover:bg-[#4A3A2A]/5 rounded-lg transition-colors"
            aria-label="Toggle menu"
          >
            {isMenuOpen ? <X size={28} /> : <Menu size={28} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden py-6 border-t border-[#4A3A2A]/10">
            <nav className="flex flex-col space-y-4">
              {navItems.map((item) => (
                <Link
                  key={item.path}
                  to={item.path}
                  onClick={() => setIsMenuOpen(false)}
                  className={`text-lg font-medium py-2 transition-colors ${
                    isActive(item.path)
                      ? "text-[#B65C3A]"
                      : "text-[#2D2D2D] hover:text-[#B65C3A]"
                  }`}
                >
                  {item.label}
                </Link>
              ))}
              <Link to="/contact" className="block" onClick={() => setIsMenuOpen(false)}>
                <Button className="bg-[#B65C3A] hover:bg-[#9d4e2f] text-white font-medium w-full">
                  Proposer un échange
                </Button>
              </Link>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
